import { Injectable, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Product } from '../models/admin.models';
import { environment } from '../../environments/environment';

export interface WishlistItem {
  productId: string;
  addedAt: string;
  product: Product;
}

@Injectable({
  providedIn: 'root'
})
export class WishlistService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.backendUrl}/users`;
  private wishlistItems = signal<WishlistItem[]>([]);

  constructor() {
    // Initial empty state, should be loaded via loadWishlist(uid)
  }

  getWishlistSignal() {
    return this.wishlistItems.asReadonly();
  }

  loadWishlist(uid: string) {
    this.http.get<WishlistItem[]>(`${this.apiUrl}/${uid}/wishlist`).subscribe({
      next: (items) => this.wishlistItems.set(items),
      error: (err) => console.error('Failed to load wishlist', err)
    });
  }

  addToWishlist(uid: string, product: Product) {
    return this.http.post<WishlistItem[]>(`${this.apiUrl}/${uid}/wishlist`, { productId: product.id }).subscribe({
      next: (updatedWishlist) => this.wishlistItems.set(updatedWishlist),
       error: (err) => console.error('Failed to add to wishlist', err)
    });
  }

  removeFromWishlist(uid: string, productId: string) {
    return this.http.delete<WishlistItem[]>(`${this.apiUrl}/${uid}/wishlist/${productId}`).subscribe({
      next: (updatedWishlist) => this.wishlistItems.set(updatedWishlist),
      error: (err) => console.error('Failed to remove from wishlist', err)
    });
  }

  isInWishlist(productId: string): boolean {
    return this.wishlistItems().some(item => item.productId === productId);
  }
}
